import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=8c14b9b8&scoped=true&"
import script from "./clean.vue?vue&type=script&lang=ts&"
export * from "./clean.vue?vue&type=script&lang=ts&"
import style0 from "./clean.vue?vue&type=style&index=0&id=8c14b9b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c14b9b8",
  null
  
)

export default component.exports